var lists_default = {
  "fontElementMap": "iBApc",
  "orderedlist": "LX8Nf",
  "bulletedlist": "JWPBS",
  "listItem": "UHdAF"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
